/* eslint-disable react/prop-types */
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import fixTableCellWidth from "utils/fixTableCellWidth";
import separate from "utils/separate";


function Row(props) {
    const { row } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ "& > *": { borderBottom: "unset" }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left" title={row.title}
                    style={fixTableCellWidth("120px")}>{row.title}</TableCell>
                <TableCell className="tablecell" align="left" title={row?.category?.name}
                    style={fixTableCellWidth("120px")}>{row?.category?.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row?.ghollak?.name}
                    style={fixTableCellWidth("120px")}>{row?.ghollak?.name}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.target_amount))}
                    style={fixTableCellWidth("130px")}>{separate(Number(row.target_amount))} تومان</TableCell>
                <TableCell className="tablecell" align="left" title={row.progress_percent}
                    style={fixTableCellWidth("130px")}>{row.progress_percent}</TableCell>
                <TableCell className="tablecell" align="left" title={row.status_name}
                    style={fixTableCellWidth("110px")}>{row.status_name}</TableCell>
                <TableCell className="tablecell" align="left" title={new Date(row.created_at).toLocaleString("fa-IR")}
                    style={fixTableCellWidth("170px")}>{new Date(row.created_at).toLocaleString("fa-IR")}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function TargetTable({ data }) {
    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead sx={{ padding: 0 }}>
                    <TableRow>
                        <TableCell className="tablecell" style={fixTableCellWidth("120px")}>نام هدف</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("120px")}>دسته بندی</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("120px")}>نام قلک</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("120px")}>مبلغ هدف</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("130px")}>درصد پیشرفت</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("110px")}>وضعیت</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>تاریخ ایجاد</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody style={{ display: "block" }}>
                    {data.length > 0 ? data.map((row) => (
                        <Row key={row.id} row={row} />
                    )) : <p style={{ fontSize: 16 }}>داده ایی یافت نشد</p>}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
